<!-- /* [NT-SEARCH-PER-TAB] 개인회원 검색 */ -->

<template>
  <div class="networkSearch">
    <section>
      <div class="inner row3_1 flex mobileFlexCol">
        <article class="wd100">
          <h1 class="mainTitle">
            네트워킹 검색
          </h1>

          <NetworkSearchFilterCorp />

          <h5 class="networkSearch__headline">총 2544개 기업</h5>
          <div class="networkSearchList">
            <div class="networkSearchItem" v-for="item in items" :key="item">
              <figure class="networkSearchItemImage">
                <img src="/images/manager/matching/demo1.png" alt="미국 국기" />
              </figure>
              <div
                class="networkSearchItemText"
                style="background-color: #F6F6F6;"
              >
                <h3 class="networkSearchItemTitle" style="color: #502423;">
                  이 순 신
                  <span class="networkSearchItem__status">연구자</span>
                </h3>
                <h5 class="networkSearchItemDesc" style="color: #502423;">
                  고령친화 의료기기 산업
                </h5>
                <div
                  style="text-align: center; padding-top: 32px; display: flex; gap: 1rem;"
                >
                  <button
                    class="networkSearchItemButton"
                    style="flex: 1;"
                    @click="closeModal, (isShowPopupViewProfilePersonal = true)"
                  >
                    프로필 보기
                  </button>
                  <button
                    class="networkSearchItemButton"
                    style="flex: 1;background-color: #26336A; color: #FFFFFF; border: 0;"
                    @click="onShowApply"
                  >
                    신청/자문하기
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <PaginationMatching />
          </div>
        </article>
      </div>
    </section>

    <PopupViewProfilePersonal
      :isModal="isShowPopupViewProfilePersonal"
      :handleToggleModal="closeModal"
      :handleOk="onShowApply"
    />
    <PopupApplyForMatching
      :isModal="isShowPopupApplyForMatching"
      :handleToggleModal="closeModal"
      :onApply="onApply"
      :onRequest="onRequest"
    />
    <PopupMatchingRequest
      :isModal="isShowPopupMatchingRequest"
      :handleToggleModal="closeModal"
    />
    <PopupNAPConsultationApplication
      :isModal="isShowPopupNAPConsultationApplication"
      :handleToggleModal="closeModal"
    />
  </div>
</template>

<script>
import PaginationMatching from "@/components/general/PaginationMatching.vue";
import NetworkSearchFilterCorp from "@/components/formControl/NetworkSearchFilterCorp.vue";
import PopupViewProfilePersonal from "./popup/PopupViewProfilePersonal.vue";
import PopupApplyForMatching from "./popup/PopupApplyForMatching.vue";
import PopupMatchingRequest from "./popup/PopupMatchingRequest.vue";
import PopupNAPConsultationApplication from "./popup/PopupNAPConsultationApplication.vue";

export default {
  name: "SearchIndividualMember",
  data() {
    return {
      items: Array.from({ length: 12 }, (_, index) => index + 1),
      isShowPopupViewProfilePersonal: false,
      isShowPopupApplyForMatching: false,
      isShowPopupMatchingRequest: false,
      isShowPopupNAPConsultationApplication: false,
    };
  },
  components: {
    NetworkSearchFilterCorp,
    PaginationMatching,
    PopupViewProfilePersonal,
    PopupApplyForMatching,
    PopupMatchingRequest,
    PopupNAPConsultationApplication,
  },
  methods: {
    closeModal() {
      this.isShowPopupViewProfilePersonal = false;
      this.isShowPopupApplyForMatching = false;
      this.isShowPopupMatchingRequest = false;
      this.isShowPopupNAPConsultationApplication = false;
    },
    onShowApply() {
      this.closeModal();
      this.isShowPopupApplyForMatching = true;
    },
    onApply() {
      this.closeModal();
      this.isShowPopupMatchingRequest = true;
    },
    onRequest() {
      this.closeModal();
      this.isShowPopupNAPConsultationApplication = true;
    },
  },
};
</script>

<style lang="scss" scoped>
// section 2
.directMatching {
  display: flex;
  border-bottom: 1px solid #d6d6d6;
  justify-content: space-between;
}

// Section 2

.btn-outlined {
  height: 53px;
  border: 1px solid #989898;
  background-color: #fff;
  width: 100%;
  font-size: 22px;
  margin-top: 16px;
  cursor: pointer;
}
</style>
